import { Injectable, inject } from '@angular/core';
import { ComponentStoreFactory } from '../../../../shared/store/common/component-store.factory';
import { Store } from '@ngrx/store';
import { PersonService } from '../../../service/person.service';
import {
    VoucherNursingCareAssessmentGridObject,
    VoucherNursingCareDiagnosisGridObject,
    VoucherNursingCareObject,
    VoucherObject,
} from '@it2go/types';
import { NursingCareService } from 'packages/client/src/app/services/nursing-care.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { selectCurrentServiceSettings } from '../../../store/person/person.selectors';
import { map } from 'rxjs/operators';
import {
    SERVICE_SETTINGS_VOUCHER_TYPE_DEFAULT,
    SERVICE_SETTINGS_VOUCHER_TYPE_KEY,
} from '@libs/types/src/services/types/service-settings-voucher.type';

interface State {
    voucher: VoucherObject | null;
    nursingCarePlan: VoucherNursingCareObject | null;
    nursingCareDiagnoses: VoucherNursingCareDiagnosisGridObject | null;
    nursingCareAssessments: VoucherNursingCareAssessmentGridObject | null;
}

const defaultState: State = {
    voucher: null,
    nursingCarePlan: null,
    nursingCareDiagnoses: null,
    nursingCareAssessments: null,
};

@Injectable()
export class VoucherNursingCarePlanDetailPageStore extends ComponentStoreFactory<State> {

    showNursingCare = toSignal(this.globalStore!.select(
        selectCurrentServiceSettings(SERVICE_SETTINGS_VOUCHER_TYPE_KEY, SERVICE_SETTINGS_VOUCHER_TYPE_DEFAULT),
    ).pipe(
        map((serviceSettingsData) => serviceSettingsData?.usePlanAndEvaluation ?? true),
    ));

    constructor() {
        super(defaultState, inject(Store), inject(NursingCareService), inject(PersonService));
    }
}
